import { DisplayInfo, Funds, GameVariant, GameVariantModeConfig, GameVariantTemplate } from '@/lib-backend';

export type VariantEntryFee =
    | { kind: 'fixed'; funds: Funds }
    | { kind: 'range'; currency: string; min: number; max: number; step: number }
    | { kind: 'none' };

export function effectiveVariantDisplayInfo(v: GameVariant): DisplayInfo {
    return v.DisplayInfo ?? v.Template.DisplayInfo;
}

export function effectiveVariantIsActive(v: GameVariant): boolean {
    return v.IsActive ?? v.Template.IsActive;
}

export function modeConfigTypeLabel(c: GameVariantModeConfig): string {
    switch (c._type) {
        case 'multiPlayerAsync': return 'Multiplayer (async)';
        case 'rolls': return 'Rolls';
        case 'singlePlayer': return 'Single player';
    }
}

export function modeConfigSummary(c: GameVariantModeConfig): string {
    switch (c._type) {
        case 'multiPlayerAsync':
            return `Max ${c.MaxPlayers} players · Entry ${formatFunds(c.EntryFee)}`;
        case 'rolls':
            return `${c.CurrencyType} · Bets ${c.RollsBetLimits.Min}–${c.RollsBetLimits.Max} (step ${c.RollsBetLimits.Step}) · House fee ${c.HouseFeePercents}%`;
        case 'singlePlayer':
            return `${c.CurrencyType}`;
    }
}

export function variantTemplateLabel(t: GameVariantTemplate): string {
    return t.DisplayInfo.Name || t.GameVariantTemplateId;
}

export function variantPlayerCount(c: GameVariantModeConfig): number | null {
    switch (c._type) {
        case 'multiPlayerAsync': return c.MaxPlayers;
        case 'singlePlayer': return 1;
        case 'rolls': return null;
    }
}

export function variantEntryFee(c: GameVariantModeConfig): VariantEntryFee {
    switch (c._type) {
        case 'multiPlayerAsync':
            return { kind: 'fixed', funds: c.EntryFee };
        case 'rolls':
            return {
                kind: 'range',
                currency: c.CurrencyType,
                min: c.RollsBetLimits.Min,
                max: c.RollsBetLimits.Max,
                step: c.RollsBetLimits.Step,
            };
        case 'singlePlayer':
            return { kind: 'none' };
    }
}

export function variantTopReward(c: GameVariantModeConfig): Funds | null {
    if (c._type !== 'multiPlayerAsync') return null;
    return c.GameReward.OrderedPlaceRewards[0]?.Funds ?? null;
}

function formatFunds(f: { FreeCredits: number; PaidCredits: number }): string {
    const parts: string[] = [];
    if (f.PaidCredits > 0) parts.push(`${f.PaidCredits} paid`);
    if (f.FreeCredits > 0) parts.push(`${f.FreeCredits} free`);
    return parts.length === 0 ? '0' : parts.join(' + ');
}
